import useDocumentTitle from 'hooks/useDocumentTitle';
import React from 'react'

const Zone = () => {
  useDocumentTitle("Zone | T360");

  return (
    <div>Zone</div>
  )
}

export default Zone